import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { GOLD, GOLD_LT, CREAM, INK, MAPS_URL } from '../theme';

const PILLARS = [
  { n: '01', t: 'Hand-Embroidery', d: 'Every couture piece passes through our karigars by hand — zardozi, dabka, and pearl work laid stitch by stitch, often over several hundred hours.' },
  { n: '02', t: 'Made to Measure', d: 'Nothing leaves the atelier off a rack. Each order is cut and fitted to the bride, with consultations along the way to get it right.' },
  { n: '03', t: 'Heirloom Technique', d: 'Our karigars carry techniques passed down through generations of Islamabad’s finest ateliers — the same hand, one generation on.' },
];

export default function About() {
  return (
    <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: '#efe4d2', minHeight: '100vh' }}>
      <Nav />
      <main id="ij-main">

      <section style={{ padding: 'clamp(64px,10vh,120px) clamp(20px,4vw,60px) clamp(48px,7vh,80px)', maxWidth: 820, margin: '0 auto' }}>
        <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD, marginBottom: 18 }}>About Us</div>
        <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(40px,6vw,72px)', lineHeight: 1.02, margin: '0 0 30px', color: CREAM }}>
          Woven in the light<br />of the old courts.
        </h1>
        <p style={{ fontSize: 19, lineHeight: 1.8, color: 'rgba(239,228,210,.82)', margin: '0 0 22px' }}>
          IJ Couture began in Islamabad with a simple belief: that bridal wear should carry the weight of ceremony — heavy with handwork, cut with care, and built to be worn once and remembered for decades.
        </p>
        <p style={{ fontSize: 19, lineHeight: 1.8, color: 'rgba(239,228,210,.7)', margin: 0 }}>
          Every piece that leaves our atelier is designed as an heirloom first and a garment second — drawing on Mughal-era ornament, old-court silhouettes, and embroidery techniques kept alive by the karigars who still practice them by hand.
        </p>
      </section>

      <section style={{ padding: 'clamp(50px,8vh,90px) clamp(20px,4vw,60px)', borderTop: '1px solid rgba(201,162,75,.2)', background: 'linear-gradient(180deg,#1a0f0c 0%,#150c09 100%)' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD_LT, marginBottom: 40 }}>The Atelier</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 'clamp(28px,4vw,50px)' }}>
            {PILLARS.map((p) => (
              <div key={p.n}>
                <div style={{ fontFamily: "'Bodoni Moda', serif", fontSize: 15, color: GOLD_LT, marginBottom: 14 }}>{p.n}</div>
                <h3 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontSize: 24, margin: '0 0 12px', color: CREAM }}>{p.t}</h3>
                <p style={{ fontSize: 16, lineHeight: 1.7, color: 'rgba(239,228,210,.65)', margin: 0 }}>{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: 'clamp(50px,8vh,90px) clamp(20px,4vw,60px)', borderTop: '1px solid rgba(201,162,75,.2)', maxWidth: 820, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD, marginBottom: 18 }}>Visit</div>
        <p style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: 'italic', fontSize: 'clamp(24px,3vw,32px)', color: CREAM, margin: '0 0 14px' }}>
          F-7 Markaz, Islamabad, Pakistan
        </p>
        <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', fontSize: 15, letterSpacing: '.1em', color: GOLD_LT, textDecoration: 'none', marginBottom: 30 }}>Get Directions →</a>
        <div>
          <Link to="/book-appointment" style={{ display: 'inline-block', fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', padding: '16px 38px', background: GOLD, color: INK, textDecoration: 'none' }}>Book an Appointment</Link>
        </div>
      </section>

      </main>
      <Footer />
    </div>
  );
}
